export function statusBadgeColor(status: string): "green" | "orange" | "gray" {
  const normalized = status.toLowerCase();
  if (normalized === "open" || normalized === "active") return "green";
  if (normalized === "draft") return "orange";
  return "gray";
}

export function formatRelativeTime(isoValue: string | null): string {
  if (!isoValue) return "Unknown time";

  const parsed = new Date(isoValue);
  if (Number.isNaN(parsed.getTime())) return "Unknown time";

  const now = Date.now();
  const diffMs = Math.max(0, now - parsed.getTime());
  const minuteMs = 60_000;
  const hourMs = 60 * minuteMs;
  const dayMs = 24 * hourMs;
  if (diffMs < hourMs) {
    const minutes = Math.max(1, Math.round(diffMs / minuteMs));
    return `${minutes}m ago`;
  }
  if (diffMs < dayMs) {
    const hours = Math.round(diffMs / hourMs);
    return `${hours}h ago`;
  }
  const days = Math.round(diffMs / dayMs);
  return `${days}d ago`;
}

export function previewText(value: string, maxLength: number): string {
  if (value.length <= maxLength) return value;
  return `${value.slice(0, maxLength - 1)}...`;
}
